/* eslint-disable no-param-reassign */
import { COMMUNITY_MEMBERS } from '../../constants/strings';

export const abbrNum = (number, decPlaces) => {
  const abbrev = ['K', 'M', 'B', 'T'];

  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = window.Math.pow(10, decPlaces);

  for (let i = abbrev.length - 1; i >= 0; i--) {
    const size = window.Math.pow(10, (i + 1) * 3);

    if (size <= number) {
      number = window.Math.round((number * decPlaces) / size) / decPlaces;

      // Case where we round up to the next abbreviation
      const isSpecificCase = number === 1000 && i < abbrev.length - 1;

      if (isSpecificCase) {
        number = 1;
        i++;
      }

      number += abbrev[i];

      break;
    }
  }

  return number;
};

const getMembersText = (count, formatMessage) => {
  const prettifiedCount = abbrNum(count, 0);
  const text = formatMessage(COMMUNITY_MEMBERS);

  return `${prettifiedCount} ${text}`;
};

export default getMembersText;



// WEBPACK FOOTER //
// ./src/utils/communities/getMembersText.js